import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 touch-manipulation",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 active:bg-primary/80",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 active:bg-destructive/80",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground active:bg-accent/80",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80 active:bg-secondary/70",
        ghost: "hover:bg-accent hover:text-accent-foreground active:bg-accent/80",
        link: "text-primary underline-offset-4 hover:underline",
        hero: "bg-brand-gradient text-primary-foreground border-0 hover:scale-[1.02] hover:shadow-[0_0_25px_hsl(var(--primary)/0.5)] active:scale-[0.98] font-semibold",
        "hero-outline": "border-2 border-surface-dark-foreground/30 text-surface-dark-foreground bg-surface-dark-foreground/10 backdrop-blur-sm hover:bg-background hover:text-foreground hover:shadow-[0_0_20px_hsl(var(--primary)/0.3)] active:scale-[0.98] font-semibold",
        cta: "bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:scale-[1.02] hover:shadow-[0_0_20px_hsl(var(--secondary)/0.4)] active:scale-[0.98] shadow-lg font-semibold",
      },
      size: {
        default: "h-10 px-4 py-2 min-h-[44px]",
        sm: "h-9 rounded-md px-3 min-h-[44px]", // Increased for mobile touch targets
        lg: "h-11 rounded-md px-8 min-h-[44px]",
        xl: "h-14 rounded-lg px-10 text-lg min-h-[48px]",
        icon: "h-10 w-10 min-h-[44px] min-w-[44px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
